import { render, staticRenderFns } from "./Campaign2021.vue?vue&type=template&id=a06e339a"
import script from "./Campaign2021.vue?vue&type=script&lang=js"
export * from "./Campaign2021.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports